<template>
    <div class="footer">
        <div class="main-content">
        <div class="signup">
            <div class="content">
                <div class="title">GET ON OUR LIST</div>
				<div class="description">Save 10% on your first order</div>
                <input 
                    v-if="!subscribed"
                    type="text" 
                    v-model="user_email" 
                    placeholder="Enter your email..."
                />
                <div v-else class="title thanks">THANKS!</div>
                <div v-if="!subscribed" class="subscribe" @click="subscribe">SUBSCRIBE</div>
            </div>
            <div class="social">
                <div @click="openLink('https://www.twitter.com/vapequeen_')" :style="{backgroundImage : `url('${require('../assets/icons/twitter.png')}')`}"></div>
                <div @click="openLink('https://www.facebook.com/VAPEQueen')" :style="{backgroundImage : `url('${require('../assets/icons/facebook.png')}')`}"></div>
                <div @click="openLink('https://www.instagram.com/vapequeen_')" :style="{backgroundImage : `url('${require('../assets/icons/instagram.png')}')`}"></div>
            </div>
        </div>
        <div class="card-box">
            <div class="footer-card">
                <h1 class="title">Location</h1>
                <p class="content">
                    5977 South University Drive <br/>
                    Davie, FL 33328
                </p>
            </div>
            <div class="footer-card">
                <h1 class="title">Contact Us</h1>
                <p class="content">
                    info@thevapequeen.com <br/>
                    (954) 530-1533
                </p>
            </div>
            <div class="footer-card">
                <h1 class="title">Hours</h1>
                <div class="content">
                <div class="hours">
                    <span>M-TH</span>&nbsp;<span>10am-8pm</span>
                </div>
                <div class="hours">
                    <span>F-SAT</span>&nbsp;<span>10am-9pm</span>
                </div>
                <div class="hours">
                    <span>SUN</span>&nbsp;<span>12pm-6pm</span>
                </div>
                </div>
            </div>
        </div>
        </div>
        <div class="warning">
            <span id="restrictions">
                You Must Be 18 or Older to Purchase Any Vape Products
            </span>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    data() {
        return {
            user_email: '',
            subscribed: false
        }
    },
    methods: {
        async subscribe() {
            await axios.post('https://api.thevapequeen.com/subscription', { subscriber: { email: this.user_email } }).catch(e => console.log(e))
            this.subscribed = true
        },
        openLink(link) {
            window.open(link, '_blank')
        }
    }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Lobster');
@import url('https://fonts.googleapis.com/css?family=Teko');
@import url('https://fonts.googleapis.com/css?family=Allerta+Stencil');
@import url('https://fonts.googleapis.com/css?family=Josefin+Sans');
$test-color: #123123;

.signup {
    width: 100%;
    max-width: 350px;
    max-height: 300px;
    margin-top: -50px;
    background-color: #fcf59e;
    position: relative;
    margin-right: 60px;
    overflow: visible;
    box-shadow: 7px 10px 5px 0 #555555aa;
    .social {
        margin-top: 25px;
        width: 100%;
        height: 95px;
        display: flex;
        justify-content: center;
        div {
            &:hover {
                cursor: pointer;
            }
            background-position: center;
            background-repeat: no-repeat;
            background-size: contain;
            width: 25%;
            height: 60%;
        }
    }
    .content {
        display: flex;
        flex-flow: column nowrap;
        align-items: center;
        width: 100%;
        height: 100%;
        top: 0;
        padding: 20px;
        input {
            &:focus {
                outline-offest: 0 !important;
                padding: 5px;
            }
            padding: 0;
            font-size: 1em;
            margin-top: 20px;
            padding: 5px;
            font-family: Josefin Sans;
        }
        .description {
            font-family: Josefin Sans; 
            font-size: 1.3em; 
			font-weight: 300; 
            text-align: center; 
            color: #040404aa; 
        }
        .title {
            font-family: 'Allerta Stencil';
            font-size: 2.2em;
            padding-top: 0.5em;
            padding-bottom: 0.5em;
            font-weight: bold;
            font-style: italic;
            text-align: center;
            color: #04040488;
            &.thanks {
                width: 90%;
                margin-top: 60px;
                margin-left: 10px;
                margin-right: 10px;
                padding: 0;
            }
        }
        .subscribe {
            font-family: 'Allerta Stencil';
            font-size: 1.8em;
            font-style: italic;
            display: flex;
            justify-content: center;
            width: 75%;
            height: 15%;
            background-color: #97d3ce;
            box-shadow: 5px 5px 0 0 #cab2e4;
            text-align: left;
            color: #fafbfb88;
            margin-top: 10%;
            &:hover {
                cursor: pointer;
            }
        }
    }
}

.footer-card {
    width: 50%;
    height: 40%;
    margin-right: 3rem;
    text-align: left;
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: flex-start;
    .title {
        padding: 3px;
        font-family: Futura, sans-serif;
        font-size: 2.5em;
        font-weight: lighter;
        color: #ffffff;
        text-align: left;
    }
    .content {
        width: 100%;
        white-space: nowrap;
        font-family: Josefin Sans, sans-serif;
        font-size: 1.7em;
        font-weight: 100;
        line-height: 1.8em;
        color: #ffffffaa;
        display: flex;
        flex-direction: column;
        align-items: left;
        .hours {
            width: 50%;
            display: flex;
            justify-content: space-between;
        }
    }
}


.footer {
    display: flex;
    flex-direction: column;
    background-image: linear-gradient(to top, #cdace4 9%, #ace4df 66%);
    .main-content {
        width: 100%;
        height: 500px;
        margin-top: 10px;
        text-align: center;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
            .card-box {
                width: 66%;
                height: auto;
                color: white;
                display: flex;
                order: -1;
                justify-content: left;
                align-content: flex-start;
                flex-flow: column wrap;
                margin-top: 10px;
                padding-top: 3.5em;
                padding-left: 3em;
            }
    }
    .warning {
        width: 100%;
        height: 4%;
        font-family: Josefin Sans;
        font-size: 1.3em;
        font-weight: 100;
        text-align: center;
        color: #ffffffaa;
    }
}

@media (max-width: 1024px) {
    .signup:before {
        width: 100%
    }
    .footer{
        max-height: none;
        flex-direction: column;
        .warning {
            margin-top: 10px;
        }
        .main-content {
            height: auto;
            flex-direction: column;
            align-items: center;
            .signup {
                margin-right: 0;
                max-height: none;
                max-width: 80%;
                margin-top: 0;
                box-shadow: 0 0 0 0;
                width: 100%;
                .title {
                    font-size: 1.8em;
                }
            }
            .card-box {
                width: 100%;
                flex-direction: row;
                flex-wrap: wrap;
                justify-content: center;
                .footer-card {
                    width: 100%;
                    margin-bottom: 1rem;
                    text-align: center;
                    .title {
                        text-align: center;
                    }
                    .hours {
                        width: 100%;
                        justify-content: center;
                    }
                }
            }
        }
    }
}

</style>
